import api from "../../app/api";

const getSystemInfo = () => {
  return api.get("/system-information/get-all.php");
};
const getVersionInfo = () => {
  return api.get("/system-information/version.php");
};
const updateSystemSoftwareFile = (payload: any) => {
  return api.post("/update/vbox-frimware-update.php", payload);
};
const updateSystemLicenseFile = (payload: any) => {
  return api.post("/license/import-license.php", payload);
};
const getFirmwareDetails = (payload: any) => {
  return api.post("/update/firmware-details.php", payload);
};
const getVib360RunningStatus = () => {
  return api.get("/tools/vib360-running-status.php");
};
const getSystemHealthMonitoringDetails = () => {
  return api.get("/tools/system-health-monitor.php");
};


export interface RunCommandPayload {
  command: string;
  cwd?: string;
}

const runCommand = (payload: RunCommandPayload) => {
  return api.post("/tools/command_console.php", payload);
};

const SystemInfoApi = {
  getSystemInfo,
  updateSystemSoftwareFile,
  updateSystemLicenseFile,
  getFirmwareDetails,
  getVersionInfo,
  getVib360RunningStatus,
  getSystemHealthMonitoringDetails,
  runCommand,
};

export default SystemInfoApi;
